import { useSyncExternalStore } from 'react'

/**
 * Whether a media query matches.
 *
 * It is read as the component renders, not corrected in an effect afterwards,
 * so nothing is laid out once for the wrong width and then again for the right
 * one. The server has no viewport and answers false.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const media = window.matchMedia(query)

      media.addEventListener('change', notify)

      return () => media.removeEventListener('change', notify)
    },
    () => window.matchMedia(query).matches,
    () => false
  )
}
